import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpHandler} from '@angular/common/http';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

import {PubNubAngular} from 'pubnub-angular2';

import {NgxSpinnerModule} from 'ngx-spinner';

import {HttpSpinnerComponent} from './http-spinner/http-spinner.component';

import {GrowlService} from './growl/growl.service';
import {KeycloakHttpService} from './keycloak/keycloak-http.service';
import {KeycloakGuardService} from './keycloak/keycloak-guard.service';
import {KeycloakHttpInterceptorService} from './keycloak/keycloak-http-interceptor.service';
import {HttpErrorMessageService} from './http/http-error-message.service';
import {UserService} from './user/user.service';
import {ConnectService} from './connect/connect.service';
import {LocalCacheService} from "./local-cache/local-cache.service";
import {LocalStorageService} from "@app/core/local-storage/local-storage.service";
import {KeycloakSupportService} from "@app/core/keycloak/keycloak-support.service";


// factory for angular 4.3 http client
export function httpFactory(httpHandler: HttpHandler) {
  return new KeycloakHttpService(httpHandler);
}


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule
  ],
  declarations: [
    HttpSpinnerComponent,
  ],
  exports: [
    HttpSpinnerComponent,
    BrowserAnimationsModule,
    NgxSpinnerModule,
  ],
  providers: [
    // Global Singleton Services

    // Connect PubNub Service
    PubNubAngular,
    ConnectService,

    // HTTP and Keycloak Security Services
    KeycloakGuardService, KeycloakSupportService, KeycloakHttpInterceptorService, HttpErrorMessageService,

    // Growl Message Service
    GrowlService,

    // User Context and Authentication Service
    UserService,

    // Local cache
    LocalCacheService,

    // Local Storage Service
    LocalStorageService,

    // Angular HTTP Client Service
    {
      provide: HttpClient,
      useFactory: httpFactory,
      deps: [HttpHandler]
    },

    // HTTP Interceptor Service
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakHttpInterceptorService,
      multi: true,
    },

    // for AngularJS
    {provide: '$scope', useExisting: '$rootScope'},
  ]
})

export class CoreModule {

  // Core Module should be only loaded by App Module. Prevent other modules to load this Core Module
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error('CoreModule can only be loaded by AppModule');
    }
  }
}
